<template src="../templates/normal_fcont_39.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'
import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import PrintButton from '../components/PrintButton'
import UseDesignPaperList from '../components/UseDesignPaperList'
import CreatorProfileMaikaKokubo from '../components/CreatorProfileMaikaKokubo'
import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadPhotoPlus from '../components/AppDownloadPhotoPlus'
export default {
  name: 'app',
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,FuncSearchGalleryQR,
   PrintButton,UseDesignPaperList,CreatorProfileMaikaKokubo,AppDownloadCreative,AppDownloadPhotoPlus
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['39-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['39-2']}
    ]};
  }
};
</script>
<style />


